import { render, staticRenderFns } from "./DispatchMailDetail.vue?vue&type=template&id=2cc4a43a&scoped=true&lang=pug"
import script from "./DispatchMailDetail.vue?vue&type=script&lang=js"
export * from "./DispatchMailDetail.vue?vue&type=script&lang=js"
import style0 from "./DispatchMailDetail.vue?vue&type=style&index=0&id=2cc4a43a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc4a43a",
  null
  
)

export default component.exports